// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__GlB17","header":"PatientQuestionnaire_header__163G1","info":"PatientQuestionnaire_info__3fdIZ"};